<template>
  <div>
    <b-card-body>
      <h3>Total Member : {{ rows }}</h3>
    </b-card-body>

    <!-- Filter -->
    <b-card-body>
      <b-row class="flex-jurustify-between flex-wrap align-items-end p-1 mb-1" style="gap: 16px;">
        <div>
          <!-- basic -->
          <b-form-group label="Cari" label-for="basicInput" class="mb-0">
            <b-form-input id="basicInput" placeholder="Search" v-model="search" />
          </b-form-group>
        </div>
        <div style="min-width: 100px;">
          <!-- basic -->
          <b-form-group label="Status" label-for="status" class="mb-0">
            <v-select v-model="selectedStatus" :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'" multiple label="name"
              :options="statusList">
            </v-select>
          </b-form-group>
        </div>

        <Can i="read" a="Member">
          <div style="min-width: 140px;">
            <!-- basic -->
            <b-form-group label="Fakultas" label-for="tahunMasuk" class="mb-0">
              <v-select v-model="selectedFakultas" :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'" multiple
                label="nama_fakultas" :options="fakultass" />
            </b-form-group>
          </div>
        </Can>

        <Can i="read" a="Member">
          <div style="min-width: 140px;">
            <!-- basic -->
            <b-form-group label="Jurusan" label-for="tahunMasuk" class="mb-0">
              <v-select v-model="selectedJurusans" :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'" multiple
                label="nama_jurusan" :options="jurusans" />
            </b-form-group>
          </div>
        </Can>


        <Can i="read" a="Member">
          <div style="min-width: 140px;">
            <!-- basic -->
            <b-form-group label="Status Phone" label-for="statusPhone" class="mb-0">
              <v-select v-model="selectedStatusPhone" :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :reduce="(option) => option.id"
                :options="[{ label: 'Verified', id: 1 }, { id: 0, label: 'Unverified' }]" />
            </b-form-group>
          </div>
        </Can>

        <div>
          <b-button v-ripple.400="'rgba(234, 84, 85, 0.15)'" variant="outline-primary" class="mt-0"
            @click="isAdvanceFilter = !isAdvanceFilter">
            <feather-icon icon="ChevronsDownIcon" class="mr-25" />
            <span>Advance Filter</span>
          </b-button>
        </div>
        <div>
          <b-button v-ripple.400="'rgba(234, 84, 85, 0.15)'" variant="outline-primary" class="mt-0"
            @click="onSearchClick">
            <feather-icon icon="SearchIcon" class="mr-25" />
            <span>Search</span>
          </b-button>
        </div>
      </b-row>

      <b-row v-if="isAdvanceFilter" class="mb-1">
        <b-col md="2" xl="2" class="mb-1">
          <!-- basic -->
          <b-form-group label="Tahun Masuk" label-for="tahunMasuk" class="mb-0">
            <b-form-input id="tahunMasuk" placeholder="1950" type="number" v-model="angkatan" />
          </b-form-group>
        </b-col>
        <b-col md="2" xl="2" class="mb-1">
          <!-- basic -->
          <b-form-group label="Join Date" label-for="joinDate" class="mb-0">
            <b-form-input id="joinDate" type="date" v-model="created_at" />
          </b-form-group>
        </b-col>
      </b-row>

      <b-button-toolbar class="d-flex justify-content-between flex-wrap pt-0"
        aria-label="Toolbar with button groups and dropdown menu">
        <!-- group -->
        <b-button-group>
          <b-button v-ripple.400="'rgba(113, 102, 240, 0.15)'" variant="outline-primary" @click="selectAllRows">
            Select All
          </b-button>
          <b-button v-ripple.400="'rgba(113, 102, 240, 0.15)'" variant="outline-primary" @click="clearSelected">
            Clear Selected
          </b-button>
          <Can i="write" a="Member">
            <b-button v-ripple.400="'rgba(113, 102, 240, 0.15)'" variant="outline-primary"
              @click="validateVerifyMember">
              Verify Selected
            </b-button>
            <b-dropdown v-ripple.400="'rgba(113, 102, 240, 0.15)'" right text="Action" variant="outline-primary">
              <b-dropdown-item @click="validateVerifyMember()">
                Verify All Selected</b-dropdown-item>
              <b-dropdown-item @click="validateUnverifyMember()">Unverify All Selected</b-dropdown-item>
              <b-dropdown-item @click="validateDeleteMember()">Delete All Selected</b-dropdown-item>
            </b-dropdown>
          </Can>
        </b-button-group>

        <Can i="read" a="SuperMember">
          <b-button-group>
            <b-button v-ripple.400="'rgba(113, 102, 240, 0.15)'" variant="outline-primary" @click="refreshPage">
              <feather-icon icon="RefreshCwIcon" />
            </b-button>
            <b-button v-ripple.400="'rgba(113, 102, 240, 0.15)'" variant="outline-primary" @click="validateExport">
              <feather-icon icon="DownloadCloudIcon" />
            </b-button>
          </b-button-group>
        </Can>

      </b-button-toolbar>
    </b-card-body>

    <!-- table -->
    <b-table ref="selectableTable" selectable :select-mode="selectMode" :items="items" :fields="getFields" responsive
      @row-selected="onRowSelected">
      <template #cell(document)="data">
        <a v-if="data.item.document" :href="data.item.document" target="_blank">Open</a>
      </template>

      <!-- Super Admin -->
      <template #cell(nama)="data">
        <span style="display: block; position: relative;">{{ data.item.nama }}
          <template v-if="data.item.is_similiar">
            <span style="position: absolute; right: -20px; top: 0;">
              <feather-icon icon="AlertTriangleIcon" size="16" style="color: #e85356;" />
            </span>
          </template>
        </span>
      </template>

      <!-- Admin Fakultas -->
      <template #cell(nama_panjang)="data">
        <span style="display: block; position: relative;">{{ data.item.nama_panjang }}
          <template v-if="data.item.is_similiar">
            <span style="position: absolute; right: -20px; top: 0;">
              <feather-icon icon="AlertTriangleIcon" size="16" />
            </span>
          </template>
        </span>
      </template>

      <template #cell(jurusan)="data">
        <div v-if="data.item.pendidikan.length > 0">
          <template v-if="data.item.pendidikan.length === 1">
            <span>{{ data.item.pendidikan[0].jurusan }}
              <feather-icon v-if="data.item.pendidikan[0].status_from_faculty === 'verified'" icon="CheckCircleIcon"
                size="16" style="color: #36c477;" />
              <feather-icon v-if="data.item.pendidikan[0].status_from_faculty === 'unverified'" icon="XCircleIcon"
                size="16" style="color: #e85356;" />
            </span>
          </template>
          <template v-else>
            <div class="d-flex align-items-center justify-content-between"
              @click="openDetailPendidikan({ jurusan: data.item.pendidikan[0].id })"><span>{{
                data.item.pendidikan[0].jurusan }}
                <feather-icon v-if="data.item.pendidikan[0].status_from_faculty === 'verified'" icon="CheckCircleIcon"
                  size="16" style="color: #36c477;" />
                <feather-icon v-if="data.item.pendidikan[0].status_from_faculty === 'unverified'" icon="XCircleIcon"
                  size="16" style="color: #e85356;" />
              </span>
              <span style="width: 30px;">
                <feather-icon icon="ChevronRightIcon" size="16"
                  :class="{ 'rotate-90': detailPendidikan.jurusan == data.item.pendidikan[0].id }" />
              </span>
            </div>
            <ul v-if="detailPendidikan.jurusan == data.item.pendidikan[0].id"
              style="list-style: none; padding-left: 0; margin-top: 3px; border-top: 1px solid #eae9ec; padding-top: 3px;">
              <li v-for="(pend, idx) in data.item.pendidikan.slice(1)" :key="idx"
                style="padding-bottom: 3px; margin-bottom: 3px; border-bottom: 1px solid #eae9ec;">
                {{ pend.jurusan || '-' }}
                <feather-icon v-if="pend.status_from_faculty === 'verified'" icon="CheckCircleIcon" size="16"
                  style="color: #36c477;" />
                <feather-icon v-if="pend.status_from_faculty === 'unverified'" icon="XCircleIcon" size="16"
                  style="color: #e85356;" />
              </li>
            </ul>
          </template>
        </div>
      </template>

      <template #cell(angkatan)="data">
        <div v-if="data.item.pendidikan.length > 0">
          <!-- Cek jumlah pendidikan -->
          <template v-if="data.item.pendidikan.length === 1">
            <!-- Kalau 1 item, langsung tampilkan -->
            <span>{{ data.item.pendidikan[0].tahun_masuk }}</span>
          </template>
          <template v-else>
            <div class="d-flex align-items-center justify-content-between"
              @click="openDetailPendidikan({ tahun_masuk: data.item.pendidikan[0].id })">
              <span>{{ data.item.pendidikan[0].tahun_masuk }}</span>
              <span style="width: 30px; margin-left: 10px;">
                <feather-icon icon="ChevronRightIcon" size="16"
                  :class="{ 'rotate-90': detailPendidikan.tahun_masuk == data.item.pendidikan[0].id }" />
              </span>
            </div>
            <ul v-if="detailPendidikan.tahun_masuk == data.item.pendidikan[0].id"
              style="list-style: none; padding-left: 0; margin-top: 3px; border-top: 1px solid #eae9ec; padding-top: 3px;">
              <li v-for="(pend, idx) in data.item.pendidikan.slice(1)" :key="idx"
                style="padding-bottom: 3px; margin-bottom: 3px; border-bottom: 1px solid #eae9ec;">
                {{ pend.tahun_masuk || '-' }}
              </li>
            </ul>
          </template>
        </div>
      </template>

      <template #cell(tahun_keluar)="data">
        <div v-if="data.item.pendidikan.length > 0">
          <!-- Cek jumlah pendidikan -->
          <template v-if="data.item.pendidikan.length === 1">
            <!-- Kalau 1 item, langsung tampilkan -->
            <span>{{ data.item.pendidikan[0].tahun_keluar }}</span>
          </template>
          <template v-else>
            <div class="d-flex align-items-center justify-content-between"
              @click="openDetailPendidikan({ tahun_keluar: data.item.pendidikan[0].id })">
              <span>{{ data.item.pendidikan[0].tahun_keluar }}</span>
              <span style="width: 30px; margin-left: 10px;">
                <feather-icon icon="ChevronRightIcon" size="16"
                  :class="{ 'rotate-90': detailPendidikan.tahun_keluar == data.item.pendidikan[0].id }" />
              </span>
            </div>
            <ul v-if="detailPendidikan.tahun_keluar == data.item.pendidikan[0].id"
              style="list-style: none; padding-left: 0; margin-top: 3px; border-top: 1px solid #eae9ec; padding-top: 3px;">
              <li v-for="(pend, idx) in data.item.pendidikan.slice(1)" :key="idx"
                style="padding-bottom: 3px; margin-bottom: 3px; border-bottom: 1px solid #eae9ec;">
                {{ pend.tahun_keluar || '-' }}
              </li>
            </ul>
          </template>
        </div>
      </template>

      <template #cell(status)="data">
        <b-badge :variant="status[1][data.value]">
          {{ status[0][data.value] }}
        </b-badge>
      </template>

      <template #cell(pddikti_check_status)="data">
        <b-badge
          :variant="data.item.pddikti_check_status == 'valid' ? 'success' : data.item.pddikti_check_status == 'invalid' ? 'danger' : 'secondary'">
          {{ data.item.pddikti_check_status }}
        </b-badge>
      </template>

      <template #cell(is_email_verified)="data">
        <b-badge :variant="statusEmail[1][data.value]">
          {{ statusEmail[0][data.value] }}
        </b-badge>
      </template>

      <template #cell(is_phone_verified)="data">
        <b-badge :variant="statusPhone[1][data.value]">
          {{ statusPhone[0][data.value] }}
        </b-badge>
      </template>

      <template #cell(action)="data">
        <!-- Action Super Admin -->
        <Can i="read" a="ListMemberAdmin">
          <b-dropdown variant="link" no-caret toggle-class="p-0" right boundary="viewport">
            <template #button-content>
              <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="primary" class="btn-icon">
                <feather-icon icon="SettingsIcon" />
              </b-button>
            </template>

            <b-dropdown-item @click="showDetailMember(data.item)">
              <feather-icon icon="AwardIcon" size="16" />
              <span class="align-middle ml-50">Riwayat Pendidikan</span>
            </b-dropdown-item>

            <b-dropdown-item>
              <role-modal :member="data.item" />
            </b-dropdown-item>
            <b-dropdown-item @click="showDetailMemberUnverify(data.item)" v-if="data.item.status == 4">
              <feather-icon icon="ZoomInIcon" size="16" />
              <span class="align-middle ml-50">Detail Unverify</span>
            </b-dropdown-item>

            <Can i="write" a="MemberVerify">
              <b-dropdown-item @click="verifySingle(data.item)">
                <feather-icon icon="CheckSquareIcon" size="16" />
                <span class="align-middle ml-50">Verify</span>
              </b-dropdown-item>
              <b-dropdown-item @click="unverifySingle(data.item)">
                <feather-icon icon="XSquareIcon" size="16" />
                <span class="align-middle ml-50">Unverify</span>
              </b-dropdown-item>
            </Can>

            <b-dropdown-item @click="editSingle(data.item)">
              <feather-icon icon="EditIcon" size="16" />
              <span class="align-middle ml-50">Edit Belum</span>
            </b-dropdown-item>


            <Can i="write" a="MemberVerify">
              <b-dropdown-item @click="deleteSingle(data.item)">
                <feather-icon icon="Trash2Icon" size="16" />
                <span class="align-middle ml-50">Delete</span>
              </b-dropdown-item>
            </Can>
          </b-dropdown>
        </Can>

        <!-- Action Admin Fakultas -->
        <Can i="read" a="AdminFakultas">
          <b-dropdown variant="link" no-caret toggle-class="p-0" right boundary="viewport">
            <template #button-content>
              <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="primary" class="btn-icon">
                <feather-icon icon="SettingsIcon" />
              </b-button>
            </template>

            <b-dropdown-item @click="verifyByFaculty(data.item)">
              <feather-icon icon="CheckSquareIcon" size="16" />
              <span class="align-middle ml-50">Valid</span>
            </b-dropdown-item>

            <b-dropdown-item @click="onUnverifyByFaculty(data.item)">
              <feather-icon icon="XSquareIcon" size="16" />
              <span class="align-middle ml-50">Invalid</span>
            </b-dropdown-item>

          </b-dropdown>
        </Can>

      </template>
    </b-table>

    <!-- Pagination -->
    <b-card-body class="d-flex justify-content-between flex-wrap pt-0">
      <div></div>
      <div class="demo-inline-spacing pt-0">
        <b-pagination v-model="currentPage" hide-goto-end-buttons :total-rows="rows" :per-page="perPage"
          @change="page => { currentPage = page }" />
      </div>
    </b-card-body>

    <!-- Modal Ecport -->
    <b-modal id="modal-export" hide-footer>
      <template #modal-title> Input Email Tujuan </template>
      <div class="d-block text-center">
        <p>
          Data yang akan diexport lebih dari <b>500</b> baris dan akan dikirim
          via email, Silahkan masukkan email anda!
        </p>
      </div>
      <b-form-group>
        <label for="email">Email:</label>
        <b-form-input id="email" type="email" placeholder="Email Address" v-model="email" />
      </b-form-group>
      <b-button class="mt-3" variant="outline-primary" block @click="exportData()">
        <feather-icon icon="DownloadCloudIcon" /> Export
      </b-button>
    </b-modal>

    <!-- Modal unverify super admin  -->
    <b-modal id="modal-unverify" hide-footer>
      <template #modal-title> Input Alasan Unverify </template>
      <div class="d-block text-center">
        <p>Apakah anda yakin? Jika ya silahkan input deskripsi.</p>
      </div>
      <b-form-group label="Type" label-for="type">
        <v-select v-model="selectedType" :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'" label="name"
          :options="typeList" />
      </b-form-group>
      <b-form-group>
        <label for="textarea-default">Alasan Unverify : </label>
        <b-form-textarea id="textarea-default" placeholder="Textarea" rows="3" v-model="descUnverify" />
      </b-form-group>

      <b-button class="mt-3" variant="outline-primary" block :disabled="selectedType == null"
        @click="changeStatusMember(4)">
        <feather-icon icon="SendIcon" /> Submit
      </b-button>
    </b-modal>

    <!-- Modal unverify admin fakultas  -->
    <b-modal id="modal-unverify-faculty" hide-footer>
      <template #modal-title> Input Alasan Unverify </template>
      <div class="d-block text-center">
        <p>Apakah anda yakin? Jika ya silahkan input deskripsi.</p>
      </div>
      <b-form-group label="Type" label-for="type">
        <v-select v-model="unverifyByFaculty.type" :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'" label="name"
          :options="typeList" required />
      </b-form-group>
      <b-form-group>
        <label for="textarea-default">Alasan Unverify : </label>
        <b-form-textarea id="textarea-default" placeholder="Textarea" rows="3" minlength="10" required
          v-model="unverifyByFaculty.rejection_reason" />
      </b-form-group>

      <b-button class="mt-3" variant="outline-primary" block :disabled="unverifyByFaculty.type == null"
        @click="onUnverifyByFaculty(data.item)">
        <feather-icon icon="SendIcon" /> Submit
      </b-button>
    </b-modal>

    <!-- Modal Detail Pendidikan  -->
    <b-modal id="modal-detail-pendidikan">
      <template #modal-title> Detail Pendidikan </template>
      <!-- Invoice Description: Total -->

      <table style="width: 100%">
        <tr>
          <td style="width: 30%">Document</td>
          <td style="width: 10%">:</td>
          <td style="width: 30%">
            <a :href="detailMember.document" target="_blank" v-if="detailMember.document">Open</a>
            <p v-else>Tidak ada</p>
          </td>
        </tr>
      </table>
      <hr class="invoice-spacing" />
      <div v-for="pendidikan in detailMember.pendidikan" :key="pendidikan.id">
        <table style="width: 100%">
          <tr>
            <td style="width: 30%">Universitas</td>
            <td style="width: 10%">:</td>
            <td style="width: 30%">{{ pendidikan.universitas }}</td>
          </tr>
          <tr>
            <td>Fakultas</td>
            <td>:</td>
            <td>{{ pendidikan.fakultas }}</td>
          </tr>
          <tr>
            <td>Jurusan</td>
            <td>:</td>
            <td>{{ pendidikan.jurusan }}</td>
          </tr>
          <tr>
            <td>Tahun Masuk</td>
            <td>:</td>
            <td>{{ pendidikan.tahun_masuk }}</td>
          </tr>
          <tr>
            <td>Tahun Keluar</td>
            <td>:</td>
            <td>{{ pendidikan.tahun_keluar }}</td>
          </tr>
          <tr>
            <td>Status</td>
            <td>:</td>
            <td>{{ pendidikan.status }}</td>
          </tr>

          <tr>
            <td>Created At</td>
            <td>:</td>
            <td>{{ pendidikan.created_at }}</td>
          </tr>
        </table>
        <hr class="invoice-spacing" />
      </div>
    </b-modal>

    <!-- Modal Detail Unverify -->
    <b-modal id="modal-detail-unverify">
      <template #modal-title> Detail Unverify </template>
      <!-- Invoice Description: Total -->
      <table style="width: 100%" v-if="detailMember.status == 4">
        <tr>
          <td>Type</td>
          <td>:</td>
          <td>
            {{ typeList[detailMember.rejection.type - 1].name }}
          </td>
        </tr>
        <tr>
          <td>Description</td>
          <td>:</td>
          <td>{{ detailMember.rejection.description }}</td>
        </tr>
      </table>
    </b-modal>
  </div>
</template>

<script>
import BCardCode from '@core/components/b-card-code/BCardCode.vue'
import {
  BTable, BButton, BFormGroup, BAvatar, BBadge, BCardBody, BPagination, BFormTextarea,
  BButtonToolbar, BButtonGroup, BDropdown, BDropdownItem, BFormInput, BRow, BCol, BModal, BCollapse,
} from 'bootstrap-vue'
import API from '@/api'
import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'
import { Can } from '@casl/vue';
import RoleModal from './Role.vue'
import store from '@/store'

export default {
  components: {
    BCardCode,
    BTable,
    BButton,
    BAvatar,
    BCardBody,
    BBadge,
    vSelect,
    BPagination,
    BButtonToolbar,
    BButtonGroup,
    BButton,
    BDropdown,
    BDropdownItem,
    BFormInput,
    BFormGroup,
    BRow,
    BCol,
    BModal,
    BFormTextarea,
    Can,
    RoleModal,
    BCollapse,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      tableKey: 0,
      currentPage: 1,
      rows: 0,
      perPage: 20,
      modes: ['multi', 'single', 'range'],
      detailPendidikan: {
        jurusan: '',
        tahun_masuk: '',
        tahun_keluar: '',
      },
      // fields: [
      //   { key: 'nama', label: 'Nama' },
      //   'email', 'fakultas', 'jurusan', 'angkatan',
      //   { key: 'pendidikan[0].tahun_keluar', label: 'tahun lulus' },
      //   'document',
      //   'status',
      //   { key: 'created_at', label: 'join date' }, 'action'
      // ],
      /* eslint-disable global-require */
      items: [],
      /* eslint-disable global-require */
      listOptionsStatusPhone: [
        { id: 1, label: 'Verified' },
        { id: 0, label: 'Unverified' }
      ],
      status: [{
        1: 'Pre Register', 2: 'Registered', 3: 'Verified', 4: 'Unverified', 5: 'Active',
      },
      {
        1: 'light-info', 2: 'light-info', 3: 'light-primary', 4: 'light-danger', 5: 'light-success',
      }],
      statusEmail: [{
        1: 'Verified', 0: 'Unverified'
      },
      {
        0: 'light-danger', 1: 'light-success',
      }],
      statusPhone: [{
        1: 'Verified', 0: 'Unverified'
      },
      {
        0: 'light-danger', 1: 'light-success',
      }],
      statusList: [
        { id: 1, name: 'Pre Register', subject: 'ListStatusAdmin' },
        { id: 2, name: 'Registered', subject: 'ListStatusAdmin' },
        { id: 3, name: 'Verified', subject: 'ListStatusAdminFakultas' },
        { id: 4, name: 'Unverified', subject: 'ListStatusAdmin' },
        { id: 5, name: 'Active', subject: 'ListStatusAdminFakultas' }
      ],
      typeList: [
        { id: 1, name: "Can't find" },
        { id: 2, name: 'Input wrong data' },
        { id: 3, name: 'Already registered/validated with different email' },
      ],

      selectMode: 'multi',
      selected: [],

      selectedJurusans: [],
      selectedFakultas: [],
      selectedStatusPhone: null,
      fakultass: [],
      jurusans: [],
      search: null,
      angkatan: null,
      email: null,
      descUnverify: null,
      detailMember: {},
      selectedStatus: [],
      isAdvanceFilter: false,
      created_at: null,
      selectedType: { id: 1, name: "Can't find" },
      singleSelected: {},

      unverifyByFaculty: {
        ids: null,
        rejection_reason: '',
        type: null,
      }
    }
  },
  computed: {
    getFields() {
      let fields = []

      if (this.$can('read', 'MemberEmail')) {
        fields = [
          { key: 'nama', label: 'Nama', sortable: true },
          'fakultas',
          'email',
          'jurusan',
          'angkatan',
          { key: 'tahun_keluar', label: 'tahun lulus' },
          { key: 'pddikti_check_status', label: 'dikti status', sortable: true },
          'document',
          'status',
          { key: 'is_email_verified', label: 'email status' },
          { key: 'is_phone_verified', label: 'phone status' },
          { key: 'created_at', label: 'join date' },
          'action',
        ]
      }

      if (this.$can('read', 'AdminFakultas')) {
        fields = [
          { key: 'nama_panjang', label: 'nama', sortable: true },
          'email',
          { key: 'no_telp', label: 'phone number' },
          'jurusan',
          'angkatan',
          { key: 'tahun_keluar', label: 'tahun lulus' },
          { key: 'status', label: 'status verifikasi pendidikan' },
          { key: 'pddikti_check_status', label: 'dikti status', sortable: true },
          'action',
        ]
      }

      return fields
    },
  },
  methods: {
    openDetailPendidikan(item) {
      this.detailPendidikan = {
        ...this.detailPendidikan,
        [Object.keys(item)[0]]: this.detailPendidikan[Object.keys(item)[0]] == item[Object.keys(item)[0]] ? '' : item[Object.keys(item)[0]],
      }
    },
    onRowSelected(items) {
      this.selected = items
    },
    selectAllRows() {
      this.$refs.selectableTable.selectAllRows()
    },
    clearSelected() {
      this.$refs.selectableTable.clearSelected()
    },
    getParamApi() {
      return {
        limit: this.perPage,
        page: this.currentPage,
        search: this.search,
        angkatan: this.angkatan,
        fakultas: this.getFakultasIds(),
        jurusan: this.getJurusansIds(),
        status: this.getStatusIds(),
        created_at: this.created_at,
        total: this.rows,
        is_phone_verified: this.selectedStatusPhone,
      }
    },
    flagSimiliarByName(dataArray, key) {
      const seen = new Set();

      return dataArray.map(item => {
        const value = item[key];
        const isFirst = !seen.has(value);
        seen.add(value);

        return {
          ...item,
          is_similiar: isFirst && dataArray.filter(i => i[key] === value).length > 1
        };
      });
    },
    sortByStatusFromFaculty(data) {
      return data.sort((a, b) => {
        const getPriority = (status) => (status === 'verified' ? 0 : 1);
        return getPriority(a.status_from_faculty) - getPriority(b.status_from_faculty);
      });
    },
    async getFakultas() {

      try {
        const { data } = await API.master.fakultaslist()
        this.fakultass = data.data
      } catch (error) {
        console.log(error)
        this.handleMsgErrors(error, 'Terjadi kesalahan silahkan coba lagi!')
      }
    },
    async getJurusans() {
      try {
        const { data } = await API.master.jurusanlist()
        this.jurusans = data?.data
      } catch (error) {
        console.log(error)
        this.handleMsgErrors(error, 'Terjadi kesalahan silahkan coba lagi!')
      }
    },
    async getMember() {
      try {
        let params = this.getParamApi()
        this.$store.commit('SET_IS_LOADING_FOR_SUBMIT', true)
        let keyFetch = ''
        if (this.$can('read', 'FetchMember')) {
          keyFetch = 'list'
        } else if (this.$can('read', 'FetchMemberByFaculty')) {
          keyFetch = 'listByFaculty'
          params = {
            ...params,
            id_faculty: store.state.user.userLoggedIn.id_fakultas,
          }
        } else {
          return
        }
        const { data } = await API.member[keyFetch](params)
        if (this.$can('read', 'FetchMember')) {
          this.items = this.flagSimiliarByName(data.data, 'nama')
          this.rows = data.total
        } else if (this.$can('read', 'FetchMemberByFaculty')) {
          this.items = this.flagSimiliarByName(data.data.data, 'nama_panjang')
          this.items = this.items.map(item => ({
            ...item,
            pendidikan: this.sortByStatusFromFaculty(item.pendidikan),
          }))
          this.rows = data.data.total
        }

        this.handleMsgSuccess('Berhasil tampilkan data member')
      } catch (error) {
        console.log(error)
        this.handleMsgErrors(error, 'Terjadi kesalahan silahkan coba lagi!')
      } finally {
        this.clearSelected()
        this.$store.commit('SET_IS_LOADING_FOR_SUBMIT', false)
      }
    },
    validateExport() {
      if (this.rows > 500) {
        this.$bvModal.show("modal-export")
      }
      else {
        this.exportData()
      }
    },
    getFakultasIds() {
      var fakultasIds = this.selectedFakultas.length > 0 ? this.selectedFakultas.map(function (item) { return item['id'] }) : null
      return fakultasIds ? fakultasIds.toString() : null
    },
    getJurusansIds() {
      var jurusanIds = this.selectedJurusans.length > 0 ? this.selectedJurusans.map(function (item) { return item['id'] }) : null;
      return jurusanIds ? jurusanIds.toString() : null
    },
    getStatusIds() {
      var statusIds = this.selectedStatus.length > 0 ? this.selectedStatus.map(function (item) { return item['id'] }) : null;
      return statusIds ? statusIds.toString() : null
    },
    getTypeId() {
      return this.selectedType.id
    },
    getMemberIds() {
      return this.selected.length > 0 ? this.selected.map(function (item) { return item['id'] }) : null
    },
    async exportData() {
      this.$store.commit('SET_IS_LOADING_FOR_SUBMIT', true)
      this.$bvModal.hide("modal-export")
      try {

        const { data } = await API.member.export(this.getParamApi())
        if (data.is_delay) {
          this.sweetAlertSuccess('Export sedang diproses, silahkan cek email secara berkala!')
        }
        else {
          window.open(data.url, '_blank');
        }

      } catch (error) {
        console.log(error)
        this.handleMsgErrors(error, 'Terjadi kesalahan silahkan coba lagi!')
      }
      finally {
        this.$store.commit('SET_IS_LOADING_FOR_SUBMIT', false)

      }
    },
    validateVerifyMember() {

      if (this.selected.length == 0) {
        this.toastError('Pilih member terlebih dahulu!')

      } else {
        this.$swal({
          title: 'Warning!',
          text: ' Apakah anda yakin?',
          icon: 'warning',
          showCancelButton: true,
          allowOutsideClick: true,
          customClass: {
            confirmButton: 'btn btn-primary',
            cancelButton: 'btn btn-outline-danger ml-1',
          },
          buttonsStyling: false,
        }).then((result) => {
          if (result.dismiss == 'cancel') {
            console.log('cancel');
          } else {
            this.changeStatusMember(3)
          }

        })

      }

    },
    validateUnverifyMember() {
      if (this.selected.length == 0) {
        this.toastError('Pilih member terlebih dahulu!')
      } else {
        this.$bvModal.show("modal-unverify")
      }
    },
    async changeStatusMember(chosenStatus) {
      this.$store.commit('SET_IS_LOADING_FOR_SUBMIT', true)
      try {
        var body = {
          status: chosenStatus,
          ids: this.getMemberIds(),
          description: this.descUnverify,
          type: this.getTypeId()
        }
        const { data } = await API.member.status(body)
        this.descUnverify = null
        this.sweetAlertSuccess('Berhasil ubah status member!')
        this.refreshPage()

      } catch (error) {
        console.log(error)
        this.handleMsgErrors(error, 'Terjadi kesalahan silahkan coba lagi!')
      }
      finally {
        this.$bvModal.hide("modal-unverify")
        this.clearSelected()


      }



    },
    validateDeleteMember() {
      if (this.selected.length == 0) {
        this.toastError('Pilih member terlebih dahulu!')

      } else {
        this.$swal({
          title: 'Warning!',
          text: ' Apakah anda yakin?',
          icon: 'warning',
          showCancelButton: true,
          allowOutsideClick: true,
          customClass: {
            confirmButton: 'btn btn-primary',
            cancelButton: 'btn btn-outline-danger ml-1',
          },
          buttonsStyling: false,
        }).then((result) => {
          if (result.dismiss == 'cancel') {
            console.log('cancel');
          } else {
            this.deleteMember()
          }

        })

      }
    },
    async deleteMember() {
      this.$store.commit('SET_IS_LOADING_FOR_SUBMIT', true)

      try {
        var body = {
          ids: this.getMemberIds(),
        }
        const { data } = await API.member.delete(body)
        this.sweetAlertSuccess('Berhasil delete member!')
        this.refreshPage()

      } catch (error) {
        console.log(error)
        this.handleMsgErrors(error, 'Terjadi kesalahan silahkan coba lagi!')
      }
      finally {
        this.$store.commit('SET_IS_LOADING_FOR_SUBMIT', false)
      }
    },
    async verifyByFaculty(item) {
      try {
        if (!this.$can('write', 'AdminFakultas')) {
          this.handleMsgErrors('Anda tidak memiliki akses untuk melakukan verifikasi member!')
          return;
        }
        this.$store.commit('SET_IS_LOADING_FOR_SUBMIT', true)
        const ids = item.pendidikan.map((p) => {
          if (p.id_fakultas !== store.state.user.userLoggedIn.id_fakultas) {
            return null
          }
          return p.id
        }).filter((id) => id !== null)
        const body = {
          ids
        }
        await API.pendidikan.verifyFromFaculty(body)
        this.handleMsgSuccess('Berhasil verifikasi member!')
        this.refreshPage();
      } catch (error) {
        console.log(error)
        this.handleMsgErrors(error, 'Terjadi kesalahan silahkan coba lagi!')
      } finally {
        this.$store.commit('SET_IS_LOADING_FOR_SUBMIT', false)
      }
    },
    async onUnverifyByFaculty(item) {
      try {
        if (!this.$can('write', 'AdminFakultas')) {
          this.handleMsgErrors(null, 'Anda tidak memiliki akses untuk melakukan un-verifikasi member!')
          return;
        }
        // if (this.unverifyByFaculty.rejection_reason.length < 10) {
        //   this.handleMsgErrors(null, 'Alasan unverify harus lebih dari 10 karakter!')
        //   return;
        // }
        this.$store.commit('SET_IS_LOADING_FOR_SUBMIT', true)
        const ids = item.pendidikan.map((p) => {
          if (p.id_fakultas !== store.state.user.userLoggedIn.id_fakultas) {
            return null
          }
          return p.id
        }).filter((id) => id !== null)
        const body = {
          // ...this.unverifyByFaculty,
          // type: this.unverifyByFaculty.type.id,
          ids: ids,
          rejection_reason: '',
          type: '',
        }
        await API.pendidikan.unverifyFromFaculty(body)
        // this.unverifyByFaculty = {
        //   ids: null,
        //   rejection_reason: '',
        //   type: null,
        // }
        this.handleMsgSuccess('Berhasil un-verifikasi member!')
        this.$bvModal.hide("modal-unverify-faculty")
        this.refreshPage();
      } catch (error) {
        console.log(error)
        this.handleMsgErrors(error, 'Terjadi kesalahan silahkan coba lagi!')
      } finally {
        this.$store.commit('SET_IS_LOADING_FOR_SUBMIT', false)
      }
    },
    showDetailMemberUnverifyFaculty(item) {
      const ids = item.pendidikan.map((p) => {
        if (p.id_fakultas !== store.state.user.userLoggedIn.id_fakultas) {
          return null
        }
        return p.id
      }).filter((id) => id !== null)
      this.unverifyByFaculty = {
        ...this.unverifyByFaculty,
        ids
      }
      this.$bvModal.show("modal-unverify-faculty")
    },
    verifySingle(data) {
      //this.clearSelected()
      this.selected = [data]
      this.changeStatusMember(3)
    },
    unverifySingle(data) {
      //this.clearSelected()
      this.selected = [data]
      this.validateUnverifyMember()
    },
    deleteSingle(data) {
      //this.clearSelected()
      this.selected = [data]
      this.validateDeleteMember()
    },
    showDetailMember(item) {
      this.detailMember = item
      this.$bvModal.show("modal-detail-pendidikan")
    },
    showDetailMemberUnverify(item) {
      this.detailMember = item
      this.$bvModal.show("modal-detail-unverify")
    },
    onSearchClick() {
      this.currentPage = 1
      this.refreshPage() 
    },
    onSortChange(sort) {
      console.log(sort)
    },
    // Tambahan: inisialisasi filter dari query param URL
    initFiltersFromQuery() {
      const query = this.$route.query

      this.items = []
      if (Object.keys(query).length === 0) {
        // Reset filter & page
        this.search = null
        this.selectedStatus = []
        this.selectedFakultas = []
        this.selectedJurusans = []
        this.selectedStatusPhone = null
        this.angkatan = null
        this.created_at = null
        this.currentPage = 1
      } else {
        if (query.search) this.search = query.search
        if (query.status) {
          this.selectedStatus = query.status.split(',').map(id => {
            return this.statusList.find(s => s.id === parseInt(id))
          }).filter(Boolean)
        } else {
          this.selectedStatus = []
        }
        if (query.fakultas) {
          this.selectedFakultas = query.fakultas.split(',').map(id => {
            return this.fakultass.find(f => f.id === parseInt(id))
          }).filter(Boolean)
        } else {
          this.selectedFakultas = []
        }
        if (query.jurusan) {
          this.selectedJurusans = query.jurusan.split(',').map(id => {
            return this.jurusans.find(j => j.id === parseInt(id))
          }).filter(Boolean)
        } else {
          this.selectedJurusans = []
        }
        if (query.is_phone_verified) {
          this.selectedStatusPhone = parseInt(query.is_phone_verified)
        } else {
          this.selectedStatusPhone = null
        }
        this.angkatan = query.angkatan || null
        this.created_at = query.created_at || null
        this.currentPage = parseInt(query.page) || 1
      }
    },
    // Tambahan: update query param sesuai filter/search saat ini
    updateQueryParams() {
      const query = {}

      if (this.search) query.search = this.search
      if (this.selectedStatus.length)
        query.status = this.selectedStatus.map(s => s.id).join(',')
      if (this.selectedFakultas.length)
        query.fakultas = this.selectedFakultas.map(f => f.id).join(',')
      if (this.selectedJurusans.length)
        query.jurusan = this.selectedJurusans.map(j => j.id).join(',')
      if (this.angkatan) query.angkatan = this.angkatan
      if (this.created_at) query.created_at = this.created_at
      if (this.selectedStatusPhone !== null)
        query.is_phone_verified = this.selectedStatusPhone

      // Selalu set page, kalau 1 boleh di-set juga untuk konsistensi
      query.page = this.currentPage || 1

      this.$router.replace({ query }).catch(() => { })
    },

    refreshPage() {
      this.updateQueryParams()  // update query param juga saat refreshPage
      this.getMember()
    },

  },
  mounted() {
    this.initFiltersFromQuery()
    this.getMember()
    this.getFakultas()
    this.getJurusans()
    this.statusList = this.statusList.map(s => {
      if (this.$can('read', s.subject)) {
        return { id: s.id, name: s.name }
      }
    })?.filter(Boolean)
  },
  watch: {
    '$route.query.status'(newStatus) {
      if (newStatus.split(',').length === 1) {
        window.location.reload();
        return;
      }
    },
    search() {
      this.currentPage = 1
      this.updateQueryParams()
    },
    selectedStatus: {
      handler() {
        this.currentPage = 1
        this.updateQueryParams()
      },
      deep: true
    },
    selectedFakultas: {
      handler() {
        this.currentPage = 1
        this.updateQueryParams()
      },
      deep: true
    },
    selectedJurusans: {
      handler() {
        this.currentPage = 1
        this.updateQueryParams()
      },
      deep: true
    },
    selectedStatusPhone() {
      this.currentPage = 1
      this.updateQueryParams()
    },
    angkatan() {
      this.currentPage = 1
      this.updateQueryParams()
    },
    created_at() {
      this.currentPage = 1
      this.updateQueryParams()
    },

    currentPage(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.updateQueryParams()  // update URL dengan current filter + page
        this.getMember()          // fetch data
      }
    },
  }
}
</script>

<style lang="scss">
.b-table-selectable {
  .feather {
    font-size: 1.3rem;
  }
}
</style>
